const VISITOR_KEY = "family_income_guard_visitor_id";
const SESSION_KEY = "family_income_guard_session_id";
const SESSION_STARTED_KEY = "family_income_guard_session_started_at";
const SESSION_TIMEOUT_MS = 30 * 60 * 1000;

function randomId(prefix) {
  const rand = Math.random().toString(36).slice(2);
  const time = Date.now().toString(36);
  return `${prefix}_${time}_${rand}`;
}

function safeLocalStorageGet(key) {
  try { return window.localStorage.getItem(key); } catch { return null; }
}

function safeLocalStorageSet(key, value) {
  try { window.localStorage.setItem(key, value); } catch {}
}

function safeSessionStorageGet(key) {
  try { return window.sessionStorage.getItem(key); } catch { return null; }
}

function safeSessionStorageSet(key, value) {
  try { window.sessionStorage.setItem(key, value); } catch {}
}

function getVisitorId() {
  let visitorId = safeLocalStorageGet(VISITOR_KEY);
  if (!visitorId) {
    visitorId = randomId("fig_v");
    safeLocalStorageSet(VISITOR_KEY, visitorId);
  }
  return visitorId;
}

function getSessionId() {
  const now = Date.now();
  const existing = safeSessionStorageGet(SESSION_KEY);
  const startedAt = Number(safeSessionStorageGet(SESSION_STARTED_KEY) || 0);

  if (existing && startedAt && now - startedAt < SESSION_TIMEOUT_MS) {
    return existing;
  }

  const sessionId = randomId("fig_s");
  safeSessionStorageSet(SESSION_KEY, sessionId);
  safeSessionStorageSet(SESSION_STARTED_KEY, String(now));
  return sessionId;
}

function getUtmParams() {
  const params = new URLSearchParams(window.location.search || "");
  const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid", "msclkid"];
  return keys.reduce((acc, key) => {
    const value = params.get(key);
    if (value) acc[key] = value;
    return acc;
  }, {});
}

function normalizePath(pathname) {
  let path = String(pathname || "/").split("?")[0].split("#")[0].trim();
  if (!path) path = "/";
  if (!path.startsWith("/")) path = `/${path}`;
  path = path.replace(/\/+/g, "/");
  if (path !== "/") path = path.replace(/\/+$/g, "");
  return path || "/";
}

function classifyPage(pathname) {
  const path = normalizePath(pathname || window.location.pathname || "/");
  if (path === "/" || path === "") return "home";
  if (path.startsWith("/publications")) return "publications_index";
  if (path.startsWith("/admin")) return "admin";
  if (path.startsWith("/login")) return "login";
  if (path.startsWith("/api")) return "api";
  if (path.startsWith("/privacy") || path.startsWith("/terms")) return "legal";
  if (/\.(js|css|png|jpg|jpeg|gif|svg|webp|ico|woff2?|map|mp4|mp3)$/i.test(path)) return "asset";
  return "publication_or_landing_page";
}

function deviceType() {
  const width = window.innerWidth || 0;
  const ua = navigator.userAgent || "";
  if (/Mobi|Android|iPhone|iPod/i.test(ua) || width < 768) return "mobile";
  if (/iPad|Tablet/i.test(ua) || width < 1024) return "tablet";
  return "desktop";
}

function buildPayload(eventType = "pageview", extra = {}) {
  const path = normalizePath(window.location.pathname || "/");
  return {
    eventType,
    visitorId: getVisitorId(),
    sessionId: getSessionId(),
    url: window.location.pathname + window.location.search,
    fullUrl: window.location.href,
    path,
    query: window.location.search || "",
    referrer: document.referrer || "",
    pageTitle: document.title || "",
    pageType: classifyPage(path),
    language: navigator.language || "",
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    screenWidth: window.screen?.width || null,
    screenHeight: window.screen?.height || null,
    viewportWidth: window.innerWidth || null,
    viewportHeight: window.innerHeight || null,
    deviceType: deviceType(),
    userAgent: navigator.userAgent || "",
    utm: getUtmParams(),
    metadata: extra || {}
  };
}

export function trackEvent(eventType = "pageview", extra = {}) {
  if (typeof window === "undefined") return;

  const payload = buildPayload(eventType, extra);
  const body = JSON.stringify(payload);

  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      const sent = navigator.sendBeacon("/api/track.php", blob);
      if (sent) return;
    }
  } catch {}

  fetch("/api/track.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true
  }).catch((err) => console.warn("Traffic logging failed:", err));
}

export default function logTraffic(extra = {}) {
  return trackEvent("pageview", extra);
}

if (typeof window !== "undefined") {
  window.figTrackEvent = trackEvent;
}
